import {
  ArrowDownLeft,
  ArrowUpRight,
  Clock3,
  Headphones,
  PhoneCall,
  UserRound,
} from 'lucide-react';
import { ticketCallPresentation } from '../TicketCallHistory';
import type { BrowserCall } from '../types';

function dateTime(value?: string | null) {
  if (!value) return 'Время не указано';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Время не указано';
  return new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}
export function TicketCallTimelineCard({ call, occurredAt }: { call: BrowserCall; occurredAt?: string | null }) {
  const presentation = ticketCallPresentation(call);
  const inbound = call.direction === 'INBOUND';
  const recordingNote = ({
    PENDING: 'Проигрыватель появится автоматически после обработки',
    DELETING: 'Файл безопасно удаляется, история звонка сохранится',
    DELETED: 'Аудиофайл удалён, сведения о звонке сохранены',
    DENIED: 'Для этой записи недостаточно прав',
    FAILED: 'Аудиофайл нельзя воспроизвести',
    EMPTY: 'Запись разговора отсутствует',
  } as Record<string, string>)[presentation.recording.kind] || 'Аудиофайл нельзя воспроизвести';

  return <div className="timeline-item phone ticket-call-timeline">
    <span className="timeline-icon"><PhoneCall /></span>
    <div className="ticket-call-event-card">
      <header>
        <span><b>{presentation.title}</b><small> · {presentation.operator}</small></span>
        <time>{dateTime(occurredAt || call.ended_at || call.answered_at || call.started_at)}</time>
      </header>
      <div className="ticket-call-event-main">
        <span className={`ticket-call-direction ${inbound ? 'inbound' : 'outbound'}`}>
          {inbound ? <ArrowDownLeft /> : <ArrowUpRight />}
        </span>
        <div className="ticket-call-party">
          <b>{presentation.contact}</b>
          <span>{presentation.number}</span>
        </div>
        <span className={`ticket-call-result ${presentation.statusTone}`}>{presentation.statusLabel}</span>
      </div>
      <div className="ticket-call-meta">
        <span><Clock3 /> {presentation.durationLabel}</span>
        <span><UserRound /> {presentation.operator}</span>
        <span><Headphones /> {presentation.extension}</span>
        <span>{presentation.directionLabel}</span>
      </div>
      <div className={`ticket-call-recording ${presentation.recording.kind.toLowerCase()}`}>
        <span><Headphones /></span>
        <div>
          <b>{presentation.recording.label}</b>
          {presentation.recording.kind === 'PLAYER'
            ? <audio aria-label={presentation.recording.label} controls preload="none" src={presentation.recording.url} />
            : <small>{recordingNote}</small>}
        </div>
      </div>
    </div>
  </div>;
}
